import React from "react"

import Layout from "../components/layout"

const ContactPage = () => {
  return (
    <Layout>
      <h1>Contact</h1>
      <p>this is contact page</p>
    </Layout>
  )
}

export default ContactPage
